export default __webpack_public_path__ + "static/media/45.550e62f0.jpg";